// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"280":"f8f6bf26","608":"336d02bf"}[chunkId] + ".js";
};